import axios from 'axios';
import { z } from 'zod';

import { strictQuery } from 'utils/strict-query';

import { EmployeeCodeValidityResponseZod, EmployerDataZod } from 'types/zod/employer-data';

const EmployerApi = {
    getEmployerByDomain: strictQuery({
        In: z.string(),
        Out: EmployerDataZod,
        handler: (domain) => axios.get(`/employer/${domain}`),
    }),
    sendCode: strictQuery({
        In: z.string(),
        Out: z.unknown(),
        handler: (email) => axios.post('/employer/code', { email }),
    }),
    linkEmployee: strictQuery({
        In: z.string(),
        Out: z.unknown(),
        handler: (code) => axios.post(`/employee/link/${code}`),
    }),
    linkDiscounter: strictQuery({
        In: z.object({ email: z.string(), domain: z.string() }),
        Out: z.unknown(),
        handler: ({ email, domain }) => axios.post(`/employee/link/${email}`, null, { params: { employer: domain } }),
    }),
    checkCodeValidity: strictQuery({
        In: z.string(),
        Out: EmployeeCodeValidityResponseZod,
        handler: (code) => axios.get('/employee/is-code-valid', { params: { code } }),
    }),
};

export default EmployerApi;
